
export const capitalizeFirstLetter = ([first, ...rest], locale = navigator.language) =>
  first === undefined ? '' : first.toLocaleUpperCase(locale) + rest.join('')


export const stringToColor = (string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export const stringAvatar = (name) => {
  if (name) {
    const arr = name.split(' ')
    return {
      style: {
        background: stringToColor(name),
      },
      children: `${arr[0][0]}${arr.length > 1 ? arr[1][0] : ''}`,
    }
  } else {
    return ''
  }
}

export const handleClipboard = (text, notify) => {
  const fallbackCopyTextToClipboard = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      if (!successful) { console.error('Copy unsuccessful') }
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(function () {
    if (notify) {
      notify('Link copiado para a área de transferência', 'info', undefined, false, 1000)
    }
  }, function (err) {
    console.error('Async: Could not copy text: ', err);
  });

}

export const orderByObjectName = (a, b) => {
  if (a && b) {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }
  return 0;
}

export const replace_params = (text, params) => {
  return text.replace(/{(.*?)}/g, (match, p1) => {
    return params[p1] !== undefined ? params[p1] : match;
  });
}

export const product_logo = (id) => {
  switch (id) {
    case 1:
      return 'https://game-juridico.s3.sa-east-1.amazonaws.com/assets/logos/Juristta_School_Button_Color.png'
    case 2:
      return 'https://game-juridico.s3.sa-east-1.amazonaws.com/assets/logos/Juristta_Office_Button_Color.png'
    case 4:
      return 'https://game-juridico.s3.sa-east-1.amazonaws.com/assets/logos/Juristta_Quiz_Button_Color.png'
    default:
      return ''
  }
}

export const product_subtitle = (id) => {
  switch (id) {
    case 1:
      return 'SIMULADOR DE PRÁTICA JURÍDICA'
    case 2:
      return 'GESTÃO DE NPJ'
    case 4:
      return 'SIMULADOS E AVALIAÇÕES'
    default:
      return ''
  }
}
